import { Box, Grid } from "@mui/material"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { Formik } from "formik"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { validationSchemaAddWeeklyQuestions } from "helpers/validationSchema"
import React, { useEffect, useRef } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { getTriviaCategoriesAction } from "redux/L&D/actions"
import { learningDevelopmentActions } from "redux/L&D/slice/user"
import UploadQuestionModal from "../../trivia-contest/NewContest/components/UploadAddUserModalAdmin"
import GenerateQuestion from "components/GenerateQuestion"

import QuestionNavBar from "../components/Navbar/QuestionNavBar"
import { addWeeklyManualQuestionV2ToBankAction } from "redux/marketing/actions"
import AddQuestions from "../components/AddQuestions"
import { formateString } from "helpers/functions"

const defaultMenuItem = "ADD"

const questionManuItems = {
  ADD_QUESTION: "ADD",
  GENERATE_QUESTION: "GENERATE",
  AUTO_SUGGEST: "AUTO"
}

const initialQuestionSet = {
  questionSet: [
    {
      uid: 0,
      duration: 60,
      question: "",
      questionType: "text",
      category: "",
      filterCategory: "",
      relatedFood: "",
      difficultyLevel: "",
      optionSet: [{ uid: "00", name: "", image: "", isCorrect: false }]
    }
  ]
}

const EditWeeklyChallengeAddQuestions = (props) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const statusRef = useRef("Draft")
  const [questionSetData, setQuestionSetData] = useState(initialQuestionSet)
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const { questionImages } = useSelector(
    (store) => store?.learningDevelopment?.trivia?.triviaContest?.newContest
  )
  const { uploadQuestionData } = useSelector((store) => store?.learningDevelopment || [])
  const { weeklyChallengeData } = useSelector((store) => store?.marketing)
  const { menuLink } = useSelector((store) => store?.learningDevelopment)
  const { flavourImages } = useSelector((store) => store?.marketing?.wineOfTheMonth || {})

  const { userRestaurant } = useSelector((store) => store.user)

  const handleSubmit = (values) => {
    const payload = {
      questions: values.questionSet?.map((questionData, index) => {
        const isMatchingType = questionData?.questionType === "matching"
        const correctCount = isMatchingType
          ? questionData.optionSet?.length || 0
          : questionData.optionSet?.filter((opt) => opt.isCorrect).length || 0
        const selection_mode = correctCount > 1 ? "MULTIPLE" : "SINGLE"

        return {
          title: questionData.question,
          category: questionData.category,
          ...(questionImages?.[index]?.id ? { image: questionImages[index].id } : {}),
          food_type: formateString(questionData.filterCategory?.toLowerCase()),
          related_food: questionData.relatedFood,
          level: questionData.difficultyLevel,
          status: "Approved",
          answers: questionData.optionSet?.map((optionData, idx) => ({
            answer: optionData.name,
            answer_image: flavourImages[idx],
            is_correct: optionData.isCorrect ? "True" : "False"
          })),
          is_moved_to_bank: true,
          is_added_manually: true,
          question_platform: userRestaurant?.name ?? "SCARPETTA",
          question_type: questionData?.questionType,
          options_count: questionData?.optionSet?.length,
          selection_mode,
          ...(questionData?.questionType === "matching" && {
            match_pairs: questionData?.optionSet?.map((option, idx) => {
              return { left_text: option.name, right_text: option.answer, order: idx + 1 }
            })
          })
        }
      })
    }

    dispatch(
      addWeeklyManualQuestionV2ToBankAction({
        payload: payload?.questions,
        handleRoute: () => {
          history.push("/learning_development/dashboard/weekly-question-bank")
        }
      })
    )
  }

  const handlePublish = ({ handleSubmit }) => {
    statusRef.current = "Published"
    handleSubmit()
    dispatch(learningDevelopmentActions.setUploadQuestionsData([]))
  }

  const checkPublish = (questions) => {
    if (questions?.length === 0) return true
    let existingCategories = props?.location?.state?.questionsCategories || []
    let totalCategories =
      questions
        ?.filter((el) => el?.status != "Pending")
        .map((el) => el?.categoryName)
        ?.filter((el) => el) || []
    return new Set([...existingCategories, ...totalCategories]).size < 5
  }

  const checkStatus = () => {
    if (weeklyChallengeData?.status?.toLowerCase() === "published") {
      return new Date(weeklyChallengeData?.start_date) > new Date()
    }
    return true
  }

  useEffect(() => {
    if (menuLink === questionManuItems.ADD_QUESTION) {
      dispatch(learningDevelopmentActions.setUploadQuestionsData([]))
    }
  }, [menuLink])

  useEffect(() => {
    if (uploadQuestionData?.length) {
      setQuestionSetData({
        questionSet: uploadQuestionData?.map((item) => {
          return {
            uid: item?.id,
            duration: item?.duration,
            question: item?.title,
            category: item?.category,
            filterCategory: item?.filter_category,
            difficultyLevel: item?.level,
            optionSet: item?.answers?.map((ans) => {
              return {
                uid: ans?.id,
                name: ans?.answer,
                isCorrect: ans?.is_correct
              }
            })
          }
        })
      })
    } else {
      return
    }
  }, [uploadQuestionData?.length])

  const handleClose = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    dispatch(getTriviaCategoriesAction())
    dispatch(learningDevelopmentActions.setUploadedImagesArr([]))
    dispatch(learningDevelopmentActions.setQuestionMenuLink(questionManuItems?.ADD_QUESTION))
  }, [])

  return (
    <Grid container>
      <UploadQuestionModal open={modalOpen} onClose={handleClose} isEdit={true} />

      <Formik
        enableReinitialize={true}
        initialValues={questionSetData}
        validationSchema={validationSchemaAddWeeklyQuestions}
        onSubmit={handleSubmit}>
        {(formik) => (
          <Grid container>
            <Grid item xs={12}>
              <Header title="Weekly Challenge" breadCrumbs={breadCrumbs}>
                {(menuLink === "" || questionManuItems?.ADD_QUESTION === menuLink) && (
                  <>
                    <AppButton onClick={() => handlePublish(formik)} sx={{ padding: "13px 80px" }}>
                      Add To Question Bank
                    </AppButton>
                  </>
                )}
              </Header>
              <QuestionNavBar activeTab={menuLink === "" ? defaultMenuItem : menuLink} />
            </Grid>
            <Grid container className="mt-3">
              {(menuLink === "" || questionManuItems?.ADD_QUESTION === menuLink) && (
                <AddQuestions
                  formik={formik}
                  questionImages={questionImages ?? []}
                  checkStatus={checkStatus}
                  checkPublish={checkPublish}
                />
              )}
              {menuLink === questionManuItems?.GENERATE_QUESTION && (
                <Box sx={{ width: "100%" }}>
                  <GenerateQuestion isWeeklyChallenge={true} />
                </Box>
              )}
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  )
}

export default EditWeeklyChallengeAddQuestions
